module.exports = __webpack_public_path__ + "img/13_4.d93cb583.png";